import { createContext } from 'react'

const templateContext = createContext()

export default templateContext
